(function ($) {
  "use strict";
  jQuery(document).ready(function() {
    // menu toggler js
    $("button.navbar-toggle").on('click', function() {
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("ov-hidden");
    });
    $(".close-box").on('click', function() {
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("ov-hidden");
    });
    // filter button js
    $("button.filter-button").on('click', function() {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
    });
    $("button.close-filter-sidebar").on('click', function() {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
    });
    // body background color js
    $(".mm-fullscreen-bg").on('click',function() {
      $(".main-menu-area").removeClass("active");
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
    $('.checkout-btn .read-agree').on('click', function () {
      if($('.cust-checkbox').is(':checked')) {
        $('.checkout-btn button.check-btn').removeAttr('disabled');
      }
      else {
        $('.checkout-btn button.check-btn').attr('disabled', 'disabled');
      }
    });
    $('.read-agree').on('click', function () {
      if($('.create-checkbox').is(':checked')) {
        $('.create').removeAttr('disabled');
      }
      else {
        $('.create').attr('disabled', 'disabled');
      }
    });
    $('.full-view, .zoom').on('click', function() {
      $('.product_img_top').magnificPopup({
        delegate: 'a',
        type:'image',
        showCloseBtn: true,
        closeBtnInside: false,
        midClick: true,
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1]
        }
      }).magnificPopup('open');
    });
    $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
      tClose: 'Close (Esc)',
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
    $('.item-data').on("click", function() {
      $(this).parents('.option-block').find(".variant-option").removeClass('active-variant');
      $(this).closest('form-wrap').addClass('active-variant');
      var it_img = $(this).attr('dataimg');
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('src',it_img);
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('srcset',it_img);
      var price = $(this).attr('dataprice');
      var compareprice = $(this).attr('datacompare');
      var stocks = $(this).attr('dataavailable');
      $(this).parents('.single-product-wrap').find('.price-box .new-price').text(Shopify.formatMoney(price, window.money_format));
      if (compareprice > price) {
        $(this).parents('.single-product-wrap').find('.price-box .old-price').show();
        $(this).parents('.single-product-wrap').find('.price-box .old-price').html(Shopify.formatMoney(compareprice, window.money_format));
      }else{
        $(this).parents('.single-product-wrap').find('.price-box .old-price').hide();
      }
    });
    var swiper = new Swiper('.drawer-slider', {
      slidesPerView: 1,
      grid: {
        rows: 1,
        fill: 'row' | 'column',
      },
      spaceBetween: 30,
      navigation: {
        nextEl: '.arrow-next-drawer',
        prevEl: '.arrow-prev-drawer',
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      speed: 1000,
    });
  });
})(jQuery);/* 7th Heaven tier drawing - Hull (Oct 2026) - draws stacked tiers with inch labels on tiered size options. Delete this block to revert. */
(function () {
  var RX = /^\s*((?:\d+"\s*\+\s*)+\d+")\s*·\s*approx\.\s*([\d.]+)\s*kg/i;
  function svg(t) {
    var W = 84, s = W / 14, h = 20, bh = 4, H = t.length * h + bh + 2, y = H - bh - h, out = '';
    t.forEach(function (d) {
      var w = d * s, x = (W - w) / 2;
      out += '<rect x="' + x.toFixed(1) + '" y="' + y + '" width="' + w.toFixed(1) + '" height="' + (h - 1) + '" rx="2" fill="#FFF6E5" stroke="#C9A44C" stroke-width="1"/>' +
        '<text x="' + (W / 2) + '" y="' + (y + h / 2 + 3.6) + '" text-anchor="middle" font-size="10.5" font-weight="700" font-family="Arial,sans-serif" fill="#7A5A1C">' + d + '&quot;</text>';
      y -= h;
    });
    var bw = (t[0] + 2) * s;
    out += '<rect x="' + ((W - bw) / 2).toFixed(1) + '" y="' + (H - bh) + '" width="' + bw.toFixed(1) + '" height="' + bh + '" rx="1.5" fill="#6FA8DC"/>';
    return { url: 'url("data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="' + W + '" height="' + H + '" viewBox="0 0 ' + W + ' ' + H + '">' + out + '</svg>') + '")', h: H };
  }
  /* Only attributes are changed (class + style), never the label's contents, so the guided-steps script is not re-triggered. */
  function apply() {
    document.querySelectorAll('label.op-lb:not(.tc-label)').forEach(function (l) {
      var inp = l.htmlFor ? document.getElementById(l.htmlFor) : null;
      var m = ((inp && inp.value) || l.textContent || '').match(RX);
      if (!m) return;
      var tiers = m[1].split('+').map(function (x) { return parseInt(x, 10); });
      var g = svg(tiers);
      l.style.setProperty('--tc-img', g.url);
      l.style.setProperty('--tc-h', g.h + 'px');
      l.style.setProperty('--tc-kg', '"approx. ' + m[2] + 'kg"');
      l.classList.add('tc-label');
    });
  }
  var css = document.createElement('style');
  css.textContent =
    'label.op-lb.tc-label{display:inline-flex!important;flex-direction:column;align-items:center;justify-content:flex-start;gap:2px;height:auto!important;min-height:0!important;white-space:normal!important;line-height:1.2!important;vertical-align:top}' +
    'label.op-lb.tc-label::before{content:"";display:block;order:0;width:84px;height:var(--tc-h);margin:2px auto 4px;background:var(--tc-img) center/contain no-repeat;flex:none}' +
    'label.op-lb.tc-label .gs-sv{order:1;font-size:14px!important;font-weight:700!important;opacity:1!important;color:inherit!important}' +
    'label.op-lb.tc-label .gs-sz{order:2;font-size:0!important;line-height:0}' +
    'label.op-lb.tc-label .gs-sz::after{content:var(--tc-kg);font-size:11.5px;font-weight:400;opacity:.7;line-height:1.3}' +
    'label.op-lb.tc-label .gs-sp{order:3}';
  document.head.appendChild(css);
  var queued = false;
  function queue() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; apply(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();